import React, { useCallback, useMemo, useRef, useState } from "react";

import axios from "axios";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import OddsDefault from "../../common/crud/OddsDefault";
import WagerTypes from "../../common/crud/WagerTypes";
import WagerTypesOnline from "../../common/crud/WagerTypesOnline";
import Loader from "../../common/loader/Loader";
import JuiceRebate from "./JuiceRebate";
import ProfileBooks from "./ProfileBooks";
import ProfileGameType from "./ProfileGameType";
import ProfileParlay from "./ProfileParlay";
import ProfileSettings from "./ProfileSettings";
import ProfileStraight from "./ProfileStraight";
import "./ProfileTabs.css";
import ProfileTeaser from "./ProfileTeaser";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { useUserRights } from "../../../contexts/UserRightsContext";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import Changes from "../../common/Changes";
import InputSelect from "../../common/InputSelect";
import ApplyToAll from "./ApplyToAll";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index || props.hidden}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ProfileTabs(props) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const history = useHistory();

  const gameTypeRef = useRef(null);
  const straightRef = useRef(null);
  const teaserRef = useRef(null);

  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /**
   * SAVE & CLOSE
   */
  const handleSave = () => {
    switch (value) {
      case 1:
        gameTypeRef.current.updateGameType();
        break;
      case 2:
        straightRef.current.updateStraight();
        break;
      case 4:
        teaserRef.current.updateTeaser();
        break;
    }
    props.UpdateProfile(props.Profile);
  };

  const handleClose = () => {
    history.push("/profiles");
  };

  /**
   * CLONE
   */
  const [idBook, setIdBook] = useState(0);
  const onIdBookChange = useCallback((b) => setIdBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    emptyValue: 0,
    value: "idBook",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [newName, setNewName] = useState("");
  const onNewNameChange = useCallback(
    (event) => setNewName(event.target.value),
    []
  );

  const [openApplyAll, setOpenApplyAll] = useState(false);
  const onOpenApplyAllChange = useCallback((open) => setOpenApplyAll(open), []);

  const [openClone, setOpenClone] = useState(false);
  const onOpenCloneChange = useCallback((open) => setOpenClone(open), []);

  const handleClone = useCallback(() => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfile_Clone`;
    axios
      .post(url, {
        IdProfile: props.Profile.idProfile,
        NewName: newName,
        IdBook: idBook,
        IdUser: userInfo.userId,
      })
      .then((response) => {
        if (response.data !== 0) {
          toast.error("Error cloning Profile");
        } else {
          toast.success("Profile cloned successfully");
        }
        setIsLoading(false);
        onOpenCloneChange(false);
      });
  }, [props.Profile, newName, idBook]);

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  if (!props.Profile) return;
  return (
    <React.Fragment>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        className="w-full mb-2 overflow-x-scroll tabs-class"
      >
        <Tab label="General" {...a11yProps(0)} />
        <Tab label="Game Type" {...a11yProps(1)} />
        <Tab label="Straight" {...a11yProps(2)} />
        <Tab label="Parlay" {...a11yProps(3)} />
        <Tab label="Teaser" {...a11yProps(4)} />
        <Tab label="Books" {...a11yProps(5)} hidden={!hasRights(337)} />
        <Tab label="Odds Default" {...a11yProps(6)} hidden={!hasRights(57)} />
        <Tab label="Wager Type" {...a11yProps(7)} hidden={!hasRights(342)} />
        <Tab
          label="Wager Type Online"
          {...a11yProps(8)}
          hidden={!hasRights(63)}
        />
        <Tab label="Juice Rebate" {...a11yProps(9)} hidden={!hasRights(124)} />
      </Tabs>
      <hr className="my-2" />
      <TabPanel className="tab-content" value={value} index={0}>
        <ProfileSettings
          Profile={props.Profile}
          UpdateProfile={props.UpdateProfile}
        ></ProfileSettings>
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={1}>
        <ProfileGameType
          ref={gameTypeRef}
          Profile={props.Profile}
        ></ProfileGameType>
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={2}>
        <ProfileStraight
          ref={straightRef}
          Profile={props.Profile}
          UpdateProfile={props.UpdateProfile}
        ></ProfileStraight>
      </TabPanel>

      <TabPanel className="tab-content" value={value} index={3}>
        <ProfileParlay
          Profile={props.Profile}
          UpdateProfile={props.UpdateProfile}
        ></ProfileParlay>
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={4}>
        <ProfileTeaser
          ref={teaserRef}
          Profile={props.Profile}
          UpdateProfile={props.UpdateProfile}
        ></ProfileTeaser>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={5}
        hidden={!hasRights(337)}
      >
        <ProfileBooks Profile={props.Profile}></ProfileBooks>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={6}
        hidden={!hasRights(57)}
      >
        <OddsDefault Profile={props.Profile}></OddsDefault>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={7}
        hidden={!hasRights(342)}
      >
        <WagerTypes Profile={props.Profile}></WagerTypes>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={8}
        hidden={!hasRights(63)}
      >
        <WagerTypesOnline Profile={props.Profile}></WagerTypesOnline>
      </TabPanel>
      <TabPanel
        className="tab-content"
        value={value}
        index={9}
        hidden={!hasRights(124)}
      >
        <JuiceRebate Profile={props.Profile}></JuiceRebate>
      </TabPanel>

      <Dialog
        open={openClone}
        onClose={onOpenCloneChange}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Clone Profile</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="flex flex-col gap-4">
              <TextField
                required
                variant="outlined"
                label="Name"
                type="text"
                value={newName}
                size="small"
                onChange={onNewNameChange}
                InputLabelProps={{ shrink: true }}
              />
              <InputSelect
                variant="outlined"
                size="small"
                label="Book"
                name="name"
                data={books}
                placeholder="DataFormatter"
                setSelectValue={onIdBookChange}
                startValue={""}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {isLoading ? (
            <div style={{ width: "8%", important: true }}>
              <Loader></Loader>
            </div>
          ) : (
            ""
          )}
          {!isLoading ? (
            <Button onClick={handleClone} color="primary" variant="contained">
              Ok
            </Button>
          ) : (
            ""
          )}
          {!isLoading ? (
            <Button
              onClick={() => onOpenCloneChange(false)}
              color="secondary"
              variant="contained"
              autoFocus
            >
              Cancel
            </Button>
          ) : (
            ""
          )}
        </DialogActions>
      </Dialog>

      <ApplyToAll
        open={openApplyAll}
        onClose={onOpenApplyAllChange}
        profile={props.Profile}
      />
      <div className="flex flex-row justify-between gap-4">
        <div className="flex flex-row gap-4">
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => onOpenApplyAllChange(true)}
          >
            Apply To All
          </Button>
          {value < 5 && (
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleSave}
            >
              Save
            </Button>
          )}
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => onOpenCloneChange(true)}
          >
            Clone
          </Button>
        </div>
        <Changes
          title={`Profile Changes`}
          buttonText={"Profile Changes"}
          params={{
            ChangeType: 11,
            IdSport: "",
            Param1: props.Profile.IdProfile,
            Param2: 0,
            Param3: 0,
          }}
        />
      </div>
    </React.Fragment>
  );
}
